export default __webpack_public_path__ + "static/media/header-img.bc6cb80a.png";